import api from "@/lib/api";

export { cad } from "@/lib/pricing";
export const day = (iso) => (iso ? new Date(iso).toLocaleDateString("en-CA", { month: "short", day: "numeric", year: "numeric" }) : "—");
export const when = (iso) => (iso ? new Date(iso).toLocaleString("en-CA", { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");
export const isPreviewHost = () => window.location.hostname.endsWith(".preview.emergentagent.com") || window.location.hostname === "localhost";
export const shortId = (id, n = 8) => (id ? (id.length > n + 2 ? `${id.slice(0, n)}…` : id) : "—");

export const errMsg = (e, fallback) => {
  const d = e?.response?.data?.detail;
  return (typeof d === "string" ? d : d?.message) || fallback;
};

export async function downloadCsv(path, params, filename) {
  const r = await api.get(path, { params, responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

const TONES = {
  green: "bg-emerald-50 text-emerald-800 border-emerald-200",
  amber: "bg-amber-50 text-amber-800 border-amber-200",
  red: "bg-rose-50 text-rose-700 border-rose-200",
  grey: "bg-slate-50 text-slate-600 border-slate-200",
};

export const STATUS = {
  PENDING: ["Pending", "amber"], AVAILABLE: ["Available", "green"], REVERSED: ["Reversed", "red"],
  REQUESTED: ["In review", "amber"], PROCESSING: ["Processing", "amber"], REFUNDED: ["Refunded", "green"],
  FAILED: ["Needs retry", "red"], REJECTED: ["Declined", "grey"], APPROVED: ["Approved", "green"],
  INITIATED: ["Awaiting payment", "grey"], PAID: ["Paid", "green"], EXPIRED: ["Expired", "grey"], AMOUNT_MISMATCH: ["Check payment", "red"],
  succeeded: ["Succeeded", "green"], pending: ["Pending", "amber"], failed: ["Failed", "red"], canceled: ["Cancelled", "grey"],
};

export function StatusChip({ status, testid }) {
  const [label, tone] = STATUS[status] || [status, "grey"];
  return <span data-testid={testid} className={`inline-flex items-center px-2.5 py-0.5 rounded-full border text-[11px] font-semibold whitespace-nowrap ${TONES[tone]}`}>{label}</span>;
}

export function Choice({ options, value, onChange, suffix = "", testid, disabled }) {
  return (
    <div className="flex flex-wrap gap-2">
      {options.map((o) => (
        <button key={o} type="button" disabled={disabled} onClick={() => onChange(o)} data-testid={`${testid}-${o}`} aria-pressed={value === o}
          className={`px-4 py-2 rounded-full text-sm font-semibold border transition-colors duration-200 disabled:opacity-50 ${value === o ? "bg-[#004C3F] text-white border-[#004C3F]" : "bg-white/70 text-slate-700 border-slate-200 hover:border-[#004C3F]/50"}`}>
          {o}{suffix}
        </button>
      ))}
    </div>
  );
}

export const Label = ({ children }) => <div className="text-[10px] uppercase tracking-widest text-slate-500 font-semibold">{children}</div>;
